export default "/images/c8f68bc769da4291c221da6b813ca400.png";